












import { Vue, Component, Prop } from 'vue-property-decorator'
import axios from 'axios'

const getDataUrl = (file: File) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = (e) => {
      resolve(reader.result)
    }

    reader.onerror = (e) => {
      reject(e)
    }

    reader.readAsDataURL(file)
  })

@Component({})
export default class Upload extends Vue {
  @Prop({ default: 'image/*' }) accept: any
  @Prop({ default: 'image' }) dir: any
  @Prop({ default: false }) showUploadList!: boolean
  @Prop({ default: false }) disabled!: boolean

  preview: any = null

  loading = false

  async fileUpload(file: File) {
    try {
      this.loading = true

      return await this.upload(file)
    } catch (ex) {
      if (!ex) {
        this.$message.error(
          '파일 업로드에 실패하였습니다. 다른 사진으로 시도해주세요.'
        )
      }

      throw ex
    } finally {
      this.loading = false
    }
  }

  remove() {
    this.$emit('upload', null)
  }

  async upload(file: File) {
    const { uploadUrl, uploadedUrl } = await this.getPresignedUrl(file)

    await axios.request({
      url: uploadUrl,
      data: file,
      method: 'PUT',
      headers: { 'Access-Control-Allow-Origin': '*' },
    })

    return uploadedUrl
  }

  async getPresignedUrl(file: File) {
    return await this.$axios.$get(
      `/api/v1/user/file/presignedUrl/${this.dir}/${file.name}`
    )
  }

  async customRequest({ file, onSuccess, onError }: any) {
    try {
      const result = await this.fileUpload(file)

      onSuccess(result)

      this.$emit('upload', result)
    } catch (ex) {
      onError(ex)
    }
  }
}
